export class PickupData {
  numberOfParcels?: number
  parcelWeight?: number
  pickupDate?: number
  info1?: string
  info2?: string

  constructor(numberOfParcels: number = 1,
              pickupDate: number = new Date(new Date().getTime() + 1000 * 60 * 60 * 24).getTime(),
              parcelWeight: number = 0,
              info1?: string,
              info2?: string) {
    this.numberOfParcels = numberOfParcels
    this.parcelWeight = parcelWeight
    this.pickupDate = pickupDate
    this.info1 = info1
    this.info2 = info2
  }
}
